<template>
  <section class="conversation-page content-box">
    <chat-list
      ref="chatList"
      :show-conversation-list="showConversationList"
      :inbox-id="inboxId"
      :is-on-expanded-layout="isOnExpandedLayout"
      @conversation-load="fetchConversationIfUnavailable"
    />
    <conversation-box
      v-if="showMessageView"
      :inbox-id="inboxId"
      :is-contact-panel-open="isContactPanelOpen"
      :is-on-expanded-layout="isOnExpandedLayout"
      @contact-panel-toggle="onToggleContactPanel"
    />
  </section>
</template>

<script>
import ChatList from 'dashboard/components/ChatList';
import ConversationBox from 'dashboard/components/widgets/conversation/ConversationBox';
import conversationViewMixin from 'dashboard/mixins/conversation/conversationViewMixin';

export default {
  components: {
    ChatList,
    ConversationBox,
  },
  mixins: [conversationViewMixin],
  props: {
    conversationId: {
      type: [String, Number],
      default: 0,
    },
    inboxId: {
      type: [String, Number],
      default: 0,
    },
  },
  mounted() {
    this.$refs.chatList.clearAdvancedFilters();
    this.$refs.chatList.resetAndFetchData();
  },
  created() {
    this.$store.dispatch('setConversationListConditions', {
      type: 'inbox',
      inboxId: this.inboxId,
    });
    if (this.hasAccounts) this.setActiveChat();
  },
};
</script>
